'use client';

import { Minus, Plus, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@kit/ui/button';

interface ParticipantSelectorProps {
  value: number;
  max: number;
  onChange: (count: number) => void;
}

export function ParticipantSelector({
  value,
  max,
  onChange,
}: ParticipantSelectorProps) {
  const { t } = useTranslation('bookings');

  return (
    <div className="flex items-center justify-between rounded-lg border p-3">
      <div className="flex items-center gap-2">
        <Users className="h-4 w-4 text-muted-foreground" />
        <span className="text-sm font-medium">{t('participants')}</span>
      </div>

      <div className="flex items-center gap-3">
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="h-8 w-8"
          disabled={value <= 1}
          onClick={() => onChange(value - 1)}
        >
          <Minus className="h-4 w-4" />
        </Button>

        <span className="w-8 text-center text-lg font-semibold tabular-nums">
          {value}
        </span>

        <Button
          type="button"
          variant="outline"
          size="icon"
          className="h-8 w-8"
          disabled={value >= max}
          onClick={() => onChange(value + 1)}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
